<template>
  <Promotion />
</template>

<script>
import Promotion from "@/components/Promotion/Promotion.vue";

export default {
  name: "PromotionView",
  components: { Promotion },
};
</script>
